export let urls_for_sat = {
  data() {
    return {
      url_for_sat_69: "http://omawww.sat.gob.mx/cifras_sat/Paginas/datos/vinculo.html?page=ListCompleta69.html",
      url_for_sat_69B: "http://omawww.sat.gob.mx/cifras_sat/Paginas/datos/vinculo.html?page=ListCompleta69B.html"
    }
  }
}